import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";
import ApplicationSurvey from "@/pages/ApplicationSurvey";
import ThankYou from "@/pages/ThankYou";
import WilloRedirect from "@/pages/WilloRedirect";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import SalesLandingPage from "@/pages/SalesLandingPage";
import SalesApplicationSurvey from "@/pages/SalesApplicationSurvey";
import SalesThankYou from "@/pages/SalesThankYou";
import SalesWilloRedirect from "@/pages/SalesWilloRedirect";
import AvoidScams from "@/pages/AvoidScams";
import ContactUs from "@/pages/ContactUs";
import Jobs from "@/pages/Jobs";

// Remove Emergent badge
if (typeof window !== "undefined") {
  const kill = () => { const el = document.getElementById("emergent-badge"); if (el) el.remove(); };
  kill();
  document.addEventListener("DOMContentLoaded", kill);
  new MutationObserver(kill).observe(document.documentElement, { childList: true, subtree: true });
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Guide funnel */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/apply" element={<ApplicationSurvey />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/willo" element={<WilloRedirect />} />
          <Route path="/avoid-scams" element={<AvoidScams />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/jobs" element={<Jobs />} />
          {/* Sales concierge funnel */}
          <Route path="/sales" element={<SalesLandingPage />} />
          <Route path="/sales/apply" element={<SalesApplicationSurvey />} />
          <Route path="/sales/willo" element={<SalesWilloRedirect />} />
          <Route path="/sales/thank-you" element={<SalesThankYou />} />
          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
